import { InjectScriptUrl, InjectScriptParams } from '../types';

/**
 * Script injector.
 *
 * @param  {String} url    Url of the script.
 * @param  {Object} params Parameters passed to script loading url.
 * @return {Promise}
 */
export default function injectScript(
    url: InjectScriptUrl,
    params: InjectScriptParams = { async: true }
): Promise<void> {
    return new Promise((resolve, reject) => {
        let prop;

        const script: HTMLScriptElement = document.createElement('script');
        script.src = url;

        for (prop in params) {
            if (params.hasOwnProperty(prop)) {
                // @ts-ignore
                script[prop] = params[prop];
            }
        }

        // @ts-ignore
        if (script.readyState) {
            // @ts-ignore IE
            script.onreadystatechange = function () {
                // @ts-ignore
                if (script.readyState === 'loaded' || script.readyState === 'complete') {
                    // @ts-ignore
                    script.onreadystatechange = null;
                    resolve();
                }
            };
        } else {
            // Others
            script.onload = function () {
                resolve();
            };
            script.onerror = function () {
                reject();
            };
        }

        const scriptTag = document.getElementsByTagName('script')[0];
        if (scriptTag && scriptTag.parentNode) {
            scriptTag.parentNode.insertBefore(script, scriptTag);
        }
    });
}
